import React, { useState, useEffect } from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider, useLocation, Navigate, Outlet } from "react-router-dom";
import AuthorListPage from "./domain/author/AuthorListPage";
import GoodsPage from "./domain/goods/GoodsPage";
/*import BookPage from "./domain/book/BookPage";*/
import AuthorDetailPage from "./domain/author/AuthorPage";

// SBCHOI
import SocialCallback from './common/layouts/header/SocialCallback';
import RegisterAuthorPage from './domain/author/RegisterAuthorPage_new'
import axios from 'axios';

import AddGoodsContainer from "./domain/goods/AddGoodsContainer";
import BookPageContainer from "./domain/book/BookPageContainer";
import PostCardContainer from "./domain/goods/PostCardContainer";
import ProfileEditContainer from "./common/layouts/mypage/ProfileEditContainer";
import MypageContainer from "./common/layouts/mypage/MypageContainer";
import Terms from "./common/layouts/policy/Terms";
import Privacy from "./common/layouts/policy/Privacy";
import Youth from "./common/layouts/policy/Youth";

import MainPageContainer from "./common/Main/Container"
import BookStoryContainer from './domain/book/BookStoryContainer'
import AuthorListContainer from './domain/author/AuthorContainer'
import AddBook from "./domain/book/AddBook";
import Admin from "./domain/admin/Admin"
import AdminAnalytics from "./domain/admin/AdminAnalytics"
import AdminAuthor from "./domain/admin/AuthorList"
import AdminDetail from "./domain/admin/detail/AdminDetail"
import AdminBook from "./domain/admin/BookList"
import AdminLoginPage from "./domain/admin/Login"
import AdminEnrollPage from './domain/admin/AuthorEnrollList'
import AuthorDetailContainer from './domain/author/AuthorDetailContainer'
import ScrollToTop from "./common/controls/ScrollToTop";
import GA4PageViewTracker from "./components/common/GA4PageViewTracker";
import BookUpdate from "./domain/book/ui/BookUpdate";
import AdminPostCard from './domain/admin/AuthorPostCard'
import PenpalWebsite from "./common/layouts/footer/BookmeetIntro";
import { LoadingProvider, useLoading } from "./common/controls/LoadingContext";
import Loading from "./common/controls/Loading";
import Home from "./common/Main/Home";
import Bookpair from "./common/Main/Bookpair";
import IndependentPage from "./common/Main/IndependentPage";
import NotificationPage from "./common/Main/NotificationPage";
import BookDetail from "./domain/admin/detail/BookDetail";
import PostCardDetail from "./domain/admin/detail/PostCardDetail";
import ReportedCommentList from "./domain/admin/ReportedCommentList";


const getKoreanDateISO = () => {

    // 이 값은 항상 UTC 시간으로 나옴
    const curr = new Date(); // 현재 시간(Locale)
    const utc = curr.getTime() + (curr.getTimezoneOffset() * 60000); // UTC 시간 계산

    // 강제 한국 시간 계산
    const KR_TIME_DIFF = 9 * 3600 * 1000; // UTC + 9시간
    const kr_curr = new Date(utc + KR_TIME_DIFF); // 한국 시간

    // 시간 포맷팅
    const year = kr_curr.getFullYear();
    const month = (kr_curr.getMonth() + 1).toString().padStart(2, '0');
    const day = kr_curr.getDate().toString().padStart(2, '0');
    const hours = kr_curr.getHours().toString().padStart(2, '0');
    const minutes = kr_curr.getMinutes().toString().padStart(2, '0');
    const seconds = kr_curr.getSeconds().toString().padStart(2, '0');
    const milliseconds = kr_curr.getMilliseconds().toString().padStart(3, '0');

    // toISOString 쓰면 다시 UTC 로 돌아감;

    const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;

    return isoString;
};



// Session tracking const ( KTC time zone (UTC is not preferred))
const TrackSessionOnRouteChange = () => {
    const location = useLocation();

    // 한국 시간대로 날짜 객체 생성
    const getKoreanDate = () => {
        return getKoreanDateISO();
    };

    const generateSessionKey = () => {
        let key = localStorage.getItem("sessionKey");
        if (!key) {
            key = `${navigator.userAgent}-${navigator.platform}-${Date.now()}`;
            localStorage.setItem("sessionKey", key);
        }
        return key;
    };
    const [sessionKey, setSessionKey] = useState(localStorage.getItem("sessionKey") || generateSessionKey());
    const [sessionStart, setSessionStart] = useState(getKoreanDate());

    const saveSessionData = async (sessionEnd: string | null = null) => {
        try {
            const email = localStorage.getItem("email");
            const token = localStorage.getItem("token");
            const emailValue = (token && email) ? email : "";

            const userId = emailValue || null; // email을 user_id로 매핑

            const sessionData = {
                sessionKey,
                sessionStart: sessionStart,  // ISO string
                sessionEnd: sessionEnd ? getKoreanDate() : null,  // ISO string
                userId,  // email 값을 user_id로 사용
                platform: navigator.platform,
                ipAddress: localStorage.getItem("ipAddress") || "unknown",
                userAgent: navigator.userAgent,
                currentPath: location.pathname,
            };
            await axios.post("/api/session", sessionData, {
                headers: { "Content-Type": "application/json" },
            });
        } catch (error) {
            // console.error("Failed to save session data:", error);
        }
    };

    useEffect(() => {
        setSessionStart(getKoreanDate());

        const handleBeforeUnload = () => {
            if (!location.pathname.includes('admin')) {
                saveSessionData(getKoreanDate());
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [sessionKey, location.pathname]);

    useEffect(() => {
        const handleRouteChange = () => {
            if (!location.pathname.includes('admin')) {
                saveSessionData(getKoreanDate());
                setSessionStart(getKoreanDate());
            }
        };

        handleRouteChange();
    }, [location.pathname]);

    return null;
};


const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
    const token = localStorage.getItem("jwtToken");
    const [shouldRedirect, setShouldRedirect] = useState(false);

    useEffect(() => {
        if (!token || token === "undefined" || token === "null") {
            alert("로그인이 필요한 서비스입니다.");
            setShouldRedirect(true);
        }
    }, [token]);

    if (!token || token === "undefined" || token === "null") {
        if (shouldRedirect) {
            return <Navigate to="/" replace />;
        }
        return null; // or a loading spinner
    }

    return <>{children}</>;
};

interface AdminRouteProps {
    children: React.ReactNode;  // ReactNode는 React 요소의 타입입니다.
}
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const token = sessionStorage.getItem("adminToken");

    if (!token || token === "undefined" || token === "null") {
        alert("관리자 권한이 필요합니다. 로그인 후 이용해 주세요.");
        return <Navigate to="/adminLogin" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

// Layout component with session tracking
const Layout = () => (
    <>

        <ScrollToTop />
        <GA4PageViewTracker />
        <TrackSessionOnRouteChange />
        <Outlet /> {/* Renders child routes */}
    </>
);

const router = createBrowserRouter([


    {
        element: <Layout />, // Track session for all routes
        children: [
            { path: "/", element: <Home /> },
            { path: "/independent", element: <IndependentPage /> },
            { path: "/notification", element: <NotificationPage /> },
            { path: "/bookpair", element: <Bookpair /> },
            { path: "/author", element: <MainPageContainer /> },
            { path: "/authorlist", element: <AuthorListContainer /> },
            { path: "/author/authordetails/:authorId", element: <AuthorDetailContainer /> },
            { path: "/postcard", element: <PostCardContainer /> },
            { path: "/book/bookdetails/:bookId", element: <BookPageContainer /> },
            { path: "/book/update", element: <BookUpdate /> },
            { path: "/bookmeetIntro", element: <PenpalWebsite /> },

            { path: "/api/sign/oauth2/callback/:platform", element: <SocialCallback /> },
            { path: "/addAuthor", element: <PrivateRoute><RegisterAuthorPage /></PrivateRoute> },
            { path: "/addBook", element: <PrivateRoute><AddBook /></PrivateRoute> },
            { path: "/mypage", element: <PrivateRoute><MypageContainer /></PrivateRoute> },
            { path: "/notifications", element: <PrivateRoute><NotificationPage /></PrivateRoute> },
            {
                path: "/profileEdit",
                element: <PrivateRoute><ProfileEditContainer /></PrivateRoute>
            },
            {
                path: "/addGoods",
                element: <PrivateRoute><AddGoodsContainer /></PrivateRoute>,
            },
            {
                path: "/book",
                element: <BookStoryContainer />
            },
            { path: "/admin", element: <AdminRoute><Admin /></AdminRoute> },
            { path: "/adminAnalytics", element: <AdminRoute><AdminAnalytics /></AdminRoute> },
            { path: "/adminAuthor", element: <AdminRoute><AdminAuthor /></AdminRoute> },
            { path: "/adminAuthorDetail", element: <AdminRoute><AdminDetail /></AdminRoute> },
            { path: "/adminBook", element: <AdminRoute><AdminBook /></AdminRoute> },
            { path: "/adminPostCard", element: <AdminRoute><AdminPostCard /></AdminRoute> },
            { path: "/adminLogin", element: <AdminLoginPage /> },
            { path: "/adminEnroll", element: <AdminRoute><AdminEnrollPage /></AdminRoute> },
            { path: "/bookDetail", element: <AdminRoute><BookDetail /></AdminRoute> },
            { path: "/postCardDetail", element: <AdminRoute><PostCardDetail /></AdminRoute> },
            { path: "/adminReportedComments", element: <AdminRoute><ReportedCommentList /></AdminRoute> },


            {
                path: "/policy/terms",
                element: <Terms />,
            },
            {
                path: "/policy/privacy",
                element: <Privacy />,
            },
            {
                path: "/policy/youth",
                element: <Youth />,
            },

        ],
    },
]);

//logout_redirect_uri
function App() {

    // @ts-ignore
    // console.log(process.env.REACT_APP_ENV);
    //  console.log(process.env.REACT_APP_ENV);
    /*

    useEffect(() => {
        const fetchIpAddress = async () => {
            try {
                const res = await axios.get("https://api.ipify.org?format=json");
                localStorage.setItem("ipAddress", res.data.ip);
                // console.log("Fetched IP Address:", res.data.ip);
            } catch (error) {
                console.error("Failed to fetch IP address:", error);
                localStorage.setItem("ipAddress", "unknown");
            }
        };

        fetchIpAddress();
    }, []);

*/

    function AppWithLoading() {
        const { isLoading } = useLoading();

        return (
            <>
                {isLoading && <Loading />}
                <RouterProvider router={router} />
            </>
        );
    }

    useEffect(() => {
        // 로드해야 할 스크립트 목록
        const scripts = [
            '/assets/vendors/js/vendors.min.js',
            '/assets/vendors/js/dataTables.min.js',
            '/assets/vendors/js/dataTables.bs5.min.js',
            '/assets/vendors/js/select2.min.js',
            '/assets/vendors/js/select2-active.min.js',
        ];

        if (!document.querySelector('script[src="https://apis.google.com/js/api.js"]')) {
            const gapiScript = document.createElement('script');
            gapiScript.src = "https://apis.google.com/js/api.js";
            gapiScript.async = true;
            document.body.appendChild(gapiScript);
        }

        const loadScripts = (list: string[], index: number = 0) => {
            if (index >= list.length) return;

            if (document.querySelector(`script[src="${list[index]}"]`)) {
                loadScripts(list, index + 1);
                return;
            }

            const script = document.createElement('script');
            script.src = list[index];
            script.async = true;

            script.onload = () => {
                // console.log(`${list[index]} loaded`);
                loadScripts(list, index + 1);
            };
            script.onerror = () => {
                console.error(`Failed to load ${list[index]}`);
                loadScripts(list, index + 1);
            };

            document.body.appendChild(script);
        };

        loadScripts(scripts);

        return () => {
            document.querySelectorAll('script').forEach((script) => {
                const src = script.src;

                if (src.includes("https://apis.google.com/js/api.js")) return;

                if (scripts.some(s => src.includes(s))) {
                    script.parentNode?.removeChild(script);
                }
            });
        };
    }, []);


    return (

        <>

            <LoadingProvider>
                <AppWithLoading />
            </LoadingProvider>
        </>

    )

}

export default App;
